import { isEmpty } from "./helpers";

export const rules = {
    required: value => !!value || 'Requerido.',
    file: (value) => {
        return (
            !value ||
            !value.length ||
            value[0].size < 52428800 ||
            `El archivo no puede pesar mas de 50MB!`
        );
    },
    email: (value) => {
        if (isEmpty(value))
            return true
          const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (Array.isArray(value))
            return value.every(val => re.test(String(val))) || 'Este campo debe ser un email valido'
          
          return re.test(String(value)) || 'Este campo debe ser un email valido'
    },
    cifOrDni: value => {
        const regex = /^([XYZ]\d{7}[A-Z])|(\d{8}[A-Z])|([ABCDEFGHJKLMNPQRSUVW]\d{7}[0-9A-J])$/;
        return regex.test(value) || 'Debe ser un CIF o DNI válido.';
    },
    number_rule: (value) => /^\d+$/.test(value) || "Campo numérico",
    phone_rule: (value) => /^\+?\d{7,15}$/.test(value) || "Número de teléfono no válido",
    emailsArray: (value) => {
        if (isEmpty(value))
            return true
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (Array.isArray(value))
            return value.every(val => re.test(String(val))) || 'Este campo debe ser un email valido'
        return re.test(String(value)) || 'Este campo debe ser un email valido'
    }
} 
